<div class="progress-header">
  <div class="flex-parent">
    <div *ngFor="let section of displaySections" class="flex-item flex-grow">
      <mat-progress-bar mode="determinate" [value]="section.progress"></mat-progress-bar>
    </div>
  </div>
  <div style="display: flex; flex-direction: row;" >
      <mat-icon cdkOverlayOrigin #trigger="cdkOverlayOrigin" class="node" (click)="isOpen = !isOpen">
        {{ !isOpen ? 'expand_less' : 'expand_more'}}</mat-icon> 
      <div class="active-section-name" (click)="isOpen = !isOpen">{{activeSectionName}}</div>
  </div>
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" [cdkConnectedOverlayHasBackdrop]="true"
[cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'" (backdropClick)="isOpen = !isOpen">
  <ul class="section-list">
    <li *ngFor="let section of displaySections" class="section-row" [ngClass]="{'section-row-active': section.isActive, 'section-row-disabled': !section.isEnabled}" (click)="selectSection(section)">
      <div class="section-name">{{section.name}}</div>
      <div class="flex-1"></div>
      <div class="checkmark" *ngIf="section.isEnabled && !section.isActive"><mat-icon>check</mat-icon></div>
    </li>
  </ul>
</ng-template>